import i18n from 'i18next';
import langs from './SCQuick3DDict.json';
import {initReactI18next} from 'react-i18next';

const resources = {
  en: {
    translation: langs.en,
  },
  ja: {
    translation: langs.ja,
  },
  de: {
    translation: langs.de,
  },
  fr: {
    translation: langs.fr,
  },
  cz: {
    translation: langs.cz,
  },
  cs: {
    translation: langs.cz,
  },
  es: {
    translation: langs.es,
  }
};

i18n
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        debug: false,
    
        interpolation: {
            escapeValue: false,
        },
        react: {
            
        },
        resources: resources
    });

export default i18n;